import { render, staticRenderFns } from "./RichEditorFloatingMenu.vue?vue&type=template&id=0b82703a&scoped=true"
import script from "./RichEditorFloatingMenu.vue?vue&type=script&lang=js"
export * from "./RichEditorFloatingMenu.vue?vue&type=script&lang=js"
import style0 from "./RichEditorFloatingMenu.vue?vue&type=style&index=0&id=0b82703a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82703a",
  null
  
)

export default component.exports